import API_Exceptions from 'src/exceptions/Api';

export const ApiExceptions: API_Exceptions = new API_Exceptions();
export type { ApiErrorMessage } from 'src/exceptions/ExceptionClass';
